
enum RequestStatus {
    error = 'error',
    loading = 'loading',
    success = 'success'
}

export { RequestStatus }